const UNSAFE_ID = /[^A-Za-z0-9._-]/g;

export interface MerchantIdSource {
  id: number;
  sku?: string | null;
  merchantId?: string | null;
}

/**
 * Commercial identity for GA4 item_id / Meta content_ids.
 * URLs keep the numeric catalog id.
 */
export function resolveMerchantId(source: MerchantIdSource | null | undefined): string {
  const explicit = (source?.merchantId ?? '').trim();
  if (explicit) {
    return explicit;
  }

  const sku = (source?.sku ?? '').trim().replace(UNSAFE_ID, '-').replace(/^-+|-+$/g, '');
  if (sku) {
    return sku;
  }

  return `ZT-${source?.id ?? 0}`;
}
